module.exports = __webpack_public_path__ + "img/AAA.38f8f4e9.jpg";